import GeneralProperties from '../../core/ComponentDocs'

export default {
    documentation : {
        ...GeneralProperties.documentation,

        mode: {
            hintTitle: "Mode",
            hintText: `Vazio: campo de arquivo padrão (comportamento original).
            <br><b>dropzone</b>: área de arrastar e soltar com lista dos arquivos selecionados, botão de remover e barra de progresso do upload.
            <br><p class='small'>No modo dropzone com <b>multiple</b>, novas seleções são somadas às anteriores.</p>`
        },

        maxSize: {
            hintTitle: "Max Size",
            hintText: `Tamanho máximo por arquivo. Número = MB (ex: <b>5</b>) ou texto com unidade (ex: <b>500KB</b>, <b>10MB</b>, <b>1GB</b>).
            <br>Arquivos maiores são recusados, exibem mensagem abaixo do campo e disparam o evento <b>invalid</b>.`
        },

        subtitle: {
            hintTitle: "Subtitle",
            hintText: "Somente no modo dropzone. Texto secundário exibido abaixo do título (placeholder)."
        },

        hint: {
            hintTitle: "Hint",
            hintText: `Somente no modo dropzone. Texto pequeno exibido abaixo da área (ex: <i>Formatos suportados: PDF, imagens (JPG/PNG)...</i>).
            <br><p class='small'>Quando vazio, é montado automaticamente a partir de <b>accept</b> e <b>maxSize</b>.</p>`
        },

        configAxiosUpload: {
            hintTitle: "Config Axios Upload",
            hintText: `Configuração do axios usada pelo upload (mesmo formato de <b>configAxiosContent</b>). Avaliada no momento do envio.
            <br>Ex: <code>{ url: '/api/arquivos', method: 'POST', headers: { Authorization: 'Bearer ...' } }</code>
            <br><p class='small'>O body multipart (FormData) é montado automaticamente; não informe Content-Type.</p>`
        },

        uploadFieldName: {
            hintTitle: "Upload Field Name",
            hintText: "Nome do campo do arquivo no FormData. Padrão: <b>file</b>. Com <b>multiple</b>, cada arquivo é anexado com o mesmo nome."
        },

        uploadExtraData: {
            hintTitle: "Upload Extra Data",
            hintText: `Campos adicionais enviados no FormData junto do arquivo. Objetos são enviados como JSON.
            <br>Ex: <code>{ tipo: 'comprovante', idPedido: 123 }</code>`
        },

        invalid: {
            hintTitle: "Invalid",
            hintText: `Disparado quando arquivos são recusados por <b>maxSize</b> (ou por <b>accept</b> no modo dropzone).
            <br>Parâmetros: <b>files</b> (arquivos recusados), <b>recusados</b> (lista de { file, motivo: 'maxSize' | 'accept' }).`
        },

        uploadProgress: {
            hintTitle: "Upload Progress",
            hintText: "Disparado durante o envio. Parâmetros: <b>percent</b> (0-100), <b>event</b>."
        },

        uploadSuccess: {
            hintTitle: "Upload Success",
            hintText: "Disparado quando o upload termina com sucesso. Parâmetro: <b>response</b> (resposta do axios)."
        },

        uploadError: {
            hintTitle: "Upload Error",
            hintText: "Disparado quando o upload falha. Parâmetro: <b>error</b>."
        },

        // Métodos públicos (via this.$getComponents().<id>):
        //   getFiles()                          -> File[] (sempre array)
        //   getFormData(extraData)              -> FormData pronto para o $axios
        //   upload(extraData)                   -> Promise com a resposta do axios
        //   readFile(tipo, arquivo, encoding)   -> Promise com o conteúdo ('text' | 'dataURL' | 'arrayBuffer' | 'binaryString')

        // label                    :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // invalidFeedbackMessage   :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // validateScript           :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // fieldState               :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // jsonId                   :{
        //     hintTitle: "",
        //     hintText:""
        // },

        // ariaInvalid              :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // autocomplete             :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // autofocus                :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // debounce                 :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // disabled                 :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // form                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // formatter                :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // lazy                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // lazyFormatter            :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // list                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // max                      :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // min                      :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // name                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // noWheel                  :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // number                   :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // placeholder              :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // plaintext                :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // readonly                 :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // required                 :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // size                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // step                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // trim                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // type                     :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // value                    :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // autocapitalize           :{
        //     hintTitle: "",
        //     hintText:""
        // },

        // blur    :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // change  :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // input   :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // update  :{
        //     hintTitle: "",
        //     hintText:""
        // },
        // keyup   :{
        //     hintTitle: "",
        //     hintText:""
        // },
    }
}
